import { createApp } from 'vue'
import { createBartender } from '@fokke-/vue-bartender.js'
import App from '@/App.vue'

const app = createApp(App)
const bartender = createBartender()

app
  .use(bartender)
  .mount('#app')
